import CalloutWithAnchorPoint from "./examples/AnchorPoint.Example";
import CalloutWithAnchorElement from "./examples/AnchorElement.Example";

export default [
    {
        title: "Anchor Point With Clipping",
        component: CalloutWithAnchorPoint,
        code: require("!raw-loader!./examples/AnchorPoint.Example")
    },
    {
        title: "Anchor Element With Clipping",
        component: CalloutWithAnchorElement,
        code: require("!raw-loader!./examples/AnchorElement.Example")
    }
];
